// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "imageMatchModal-module--actionButtonsContainer--b9ab5";
export var headerImage = "imageMatchModal-module--headerImage--8e29d";
export var imageMatchContent = "imageMatchModal-module--imageMatchContent--c26c9";
export var imagesContainer = "imageMatchModal-module--imagesContainer--c86f7";
export var infoText = "imageMatchModal-module--infoText--6a0e0";
export var progressBarContainer = "imageMatchModal-module--progressBarContainer--0ca93";